import type { Control, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormFieldController } from "../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { FormFieldLabel } from "../../../../../BuildingBlocks/Forms/MantineFormFields/FormFieldLabel";
import { HelperText } from "../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/HelperText";
import { getErrorKeyFromFieldError } from "../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/utils/getErrorKeyFromFieldError";
import type { Contract } from "../../../../DeliveryOverview.types";
import {
  CONTRACT_FORM_FIELD_DATA,
  CONTRACT_FORM_HELP_TEXTS
} from "../ContractForm.constants";

interface AutomaticExtensionFieldsProps {
  control: Control<Contract>;
  errors: FieldErrors<Contract>;
}

function AutomaticExtensionFields({
  control,
  errors
}: AutomaticExtensionFieldsProps) {
  const { t } = useTranslation();
  const extensionErrorKey = getErrorKeyFromFieldError(
    errors.extension_duration_value || errors.extension_duration_unit
  );
  const extensionError = extensionErrorKey && t(extensionErrorKey);
  const cancelationErrorKey = getErrorKeyFromFieldError(
    errors.cancelation_deadline_unit ||
      errors.cancelation_deadline_value ||
      errors.cancelation_reference
  );
  const cancelationError = cancelationErrorKey && t(cancelationErrorKey);

  return (
    <div className="AutomaticExtensionFields">
      <div>
        <FormFieldLabel
          htmlFor="id_form_extension_duration_value"
          label="Ohne fristgerechte Kündigung automatische Verlängerung des Vertrages um"
        />
        <div style={{ display: "flex" }}>
          <FormFieldController
            control={control}
            data={{
              ...CONTRACT_FORM_FIELD_DATA.extension_duration_value,
              label: undefined
            }}
          />
          <FormFieldController
            control={control}
            data={{
              ...CONTRACT_FORM_FIELD_DATA.extension_duration_unit,
              label: undefined
            }}
          />
        </div>
        <HelperText error={extensionError} />
      </div>

      <div>
        <FormFieldLabel
          helpText={CONTRACT_FORM_HELP_TEXTS.cancelation_reference}
          htmlFor="id_form_cancelation_deadline_value"
          label="Die Kündigungsfrist beträgt"
        />
        <div style={{ display: "flex" }}>
          <FormFieldController
            control={control}
            data={{
              ...CONTRACT_FORM_FIELD_DATA.cancelation_deadline_value,
              label: undefined
            }}
          />
          <FormFieldController
            control={control}
            data={{
              ...CONTRACT_FORM_FIELD_DATA.cancelation_deadline_unit,
              label: undefined
            }}
          />
          <span className="text-between-fields">zum</span>
          <FormFieldController
            control={control}
            data={{
              ...CONTRACT_FORM_FIELD_DATA.cancelation_reference,
              label: undefined
            }}
          />
        </div>
        <HelperText error={cancelationError} />
      </div>
    </div>
  );
}

export { AutomaticExtensionFields };
